"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertJsonToTenantCultureDto = void 0;
var _camelcaseKeys = _interopRequireDefault(require("camelcase-keys"));
const localeRegexLiteral = /^[a-z]{2}-[A-Z]{2}$/;

/**
 * Converts JSON object (e.g. API response) with PascalCase keys format to JSON object as StaticCultureTenantCultureDto with camelCase keys format.
 * The function is primarily intended for use in tests when you need to mock the culture settings or you want to get a value for the `CultureProvider`.
 * @param value A JSON object
 * @returns A JSON object with camelCase keys format
 */
const convertJsonToTenantCultureDto = value => (0, _camelcaseKeys.default)(value, {
  deep: true,
  exclude: [localeRegexLiteral]
});
exports.convertJsonToTenantCultureDto = convertJsonToTenantCultureDto;
//# sourceMappingURL=convertJsonToTenantCultureDto.js.map